import { mapGetters } from 'vuex'
import * as CONST from '@/constants'

export default {
  computed: {
    ...mapGetters(['_T', 'delivery_available', 'currentStore', 'order_type']),
    deliveryTime() {
      if (this.currentStore && this.currentStore.delivery_duration) {
        const [days, hours, mins] = this.currentStore.delivery_duration.split(
          ':'
        )
        let str = ''
        if (parseInt(days)) {
          str = `<span>${parseInt(days)}</span>&nbsp;` + this._T('Days')
        }

        if (parseInt(hours)) {
          if (str) {
            str += this._T(', ')
          }
          str += `<span>${parseInt(hours)}</span>&nbsp;` + this._T('Hours')
        }

        if (parseInt(mins)) {
          if (str) {
            str += ' ' + this._T('and') + ' '
          }
          // added parceInt because badr wants to update number like 4 not 04
          str += `<span>${parseInt(mins)}</span>&nbsp;` + this._T('Minutes')
        }
        if (this.order_type === CONST.ORDER_TYPE_ONLINE) {
          str += ' ' + this._T('or')
        }
        return str || this._T('As soon as possible')
      }
    },
    showAlertOnCurrentRoute() {
      if (
        this.currentStore &&
        this.currentStore.delivery_alert_on &&
        this.currentStore.delivery_alert_on.length
      ) {
        const routes = {
          checkout_page: ['brand_checkout', 'goorder_checkout'],
          home_page: [
            'brand_store_page_category',
            'goorder_store_page_category',
            'goorder_store_page',
            'brand_store_page',
          ],
        }
        let currentPage = false

        for (let page in routes) {
          if (routes[page].includes(this.$route.name)) {
            currentPage = page
          }
        }
        return this.currentStore.delivery_alert_on.includes(currentPage)
      }
      return false
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.delivery_available && !this.delivery_available.available) {
        if (this.showAlertOnCurrentRoute) {
          this.$store.dispatch('showNotification', {
            text:
              this._T(
                `Store orders are delivered between ${this.delivery_available.open} and ${this.delivery_available.close}.`
              ) + this._T(` Your order ll be delivered next day.`),
            status: 'alert',
            static: true,
          })
        }
      }
    })
  },
}
